export default __webpack_public_path__ + "static/media/1.1cbb64b1.png";